<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="col-md-12">
        <div class="input-group">
          <span class="input-group-text">Target Weight (lbs)</span>
          <input
            type="Number"
            aria-label="weight"
            class="form-control custom-target-input"
            v-model="weight"
            step="any"
            min="0"
            @keyup="isSave = true"
            @change="isSave = true"
          />
          <span class="input-group-text">Target Bodyfat (%)</span>
          <input
            type="Number"
            aria-label="weight"
            class="form-control custom-target-input"
            v-model="fat"
            step="any"
            min="0"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-6">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="save()"
            >
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZDialog from '@/Components/ZElements/Dialog'
import ZInput from '@/Components/ZElements/Input'
export default {
  name: 'targets-dialog',
  components: {
    ZDialog,
    ZInput,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
      targetFat: 0,
      targetWeight: 0,
    }
  },
  computed: {
    ...mapGetters('bodycomposition', ['bodycomposition']),
    ...mapGetters('usercardio', ['member', 'summary']),
    isVisible() {
      return this.show
    },
    title() {
      let _title = 'Targets'
      if (this.member) {
        _title += ` for ${this.member.firstName} ${this.member.lastName}`
      }
      return _title
    },
    id() {
      let _id = ''
      if (this.member) {
        _id = this.member.id
      }
      return _id
    },
    weight: {
      get() {
        let _data = 0
        if (this.bodycomposition) {
          _data = this.bodycomposition.targetBodyWeight
          this.targetWeight = this.bodycomposition.targetBodyWeight
        }
        return _data
      },
      set(value) {
        this.targetWeight = value
      },
    },
    fat: {
      get() {
        let _data = 0
        if (this.bodycomposition) {
          _data = this.bodycomposition.targetBodyFat
          this.targetFat = this.bodycomposition.targetBodyFat
        }
        return _data
      },
      set(value) {
        this.targetFat = value
      },
    },
  },
  methods: {
    ...mapActions('bodycomposition', ['saveTarget']),
    async save() {
      let data = {
        user_id: this.member ? this.member.id : null,
        currentbodyweight: this.bodycomposition
          ? this.bodycomposition.bodyWeight
          : null,
        currentbodyfat: this.bodycomposition
          ? this.bodycomposition.bodyFat
          : null,
        targetbodyweight: this.targetWeight,
        targetbodyfat: this.targetFat,
      }
      console.log('Save Targets', data)
      if (data.user_id) {
        await this.saveTarget(data)
      }
      this.isSave = false
      this.$emit('saved')
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-target-input {
  text-align: right;
}
</style>
